import { render, staticRenderFns } from "./Accounter.vue?vue&type=template&id=71dc56fa&"
import script from "./Accounter.vue?vue&type=script&lang=js&"
export * from "./Accounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports